import { produce } from 'immer'
import { forEach, remove } from 'lodash'
import { PurchaseOrderItemData } from '../apis/purchaseOrderItem.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    purchaseOrderItems: PurchaseOrderItemData[]
  ): TableHorizontalData<PurchaseOrderItemData>[] {
    forEach(purchaseOrderItems,
      (item: TableHorizontalData<PurchaseOrderItemData>) => {
        const actions: ActionName[] = ['view', 'edit']
        if (!item.isDeleted) actions.push('delete')
        item.actions = actions
      })
    return purchaseOrderItems
  },

  delete (
    purchaseOrderItems: TableHorizontalData<PurchaseOrderItemData>[],
    id: number
  ) {
    return produce(purchaseOrderItems, purchaseOrderItem => {
      remove(purchaseOrderItem, { id })
    })
  }
}
